/**
 * `inertHtml` -- the last step before `dangerouslySetInnerHTML` (SA-06, docs/security/AUDIT-2026-10.md).
 *
 * The server hands these components strings that carry the ENGINE'S OWN markup on purpose: the five
 * inline tags `b i em strong br` with no attributes (`server/narrative_html.py`) and character
 * references such as `&mdash;`. Some of them (the "Your Home" rows) are also text read off an
 * uploaded document and were not escaped on the way in, so this makes the sink safe on its own
 * instead of trusting every producer.
 *
 * It keeps exactly that allow-list and turns every other `<` into `&lt;`, so a tag with an
 * attribute, an `<img>`, a `<script>` or a stray bracket shows up as visible text and creates no
 * element. It never touches `&`, so `&mdash;`, `&amp;` and `&lt;` the server wrote pass through
 * unchanged, and an ordinary value is returned byte for byte.
 */
const ALLOWED = /^<\/?(?:b|i|em|strong|br)\s*\/?>/i;

export function inertHtml(html: string): string {
  if (!html || html.indexOf("<") === -1) return html;
  let out = "";
  let i = 0;
  while (i < html.length) {
    const ch = html[i];
    if (ch === "<") {
      const m = ALLOWED.exec(html.slice(i));
      if (m) {
        out += m[0];
        i += m[0].length;
        continue;
      }
      out += "&lt;";
    } else if (ch === ">") {
      out += "&gt;";
    } else {
      out += ch;
    }
    i += 1;
  }
  return out;
}
